import { render, staticRenderFns } from "./search-item.vue?vue&type=template&id=91f74512&scoped=true"
import script from "./search-item.vue?vue&type=script&lang=js"
export * from "./search-item.vue?vue&type=script&lang=js"
import style0 from "./search-item.vue?vue&type=style&index=0&id=91f74512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f74512",
  null
  
)

export default component.exports